import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=64add2be&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64add2be')) {
      api.createRecord('64add2be', component.options)
    } else {
      api.reload('64add2be', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=64add2be&", function () {
      api.rerender('64add2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wo5Q3uq8zrpG/JS/offershelp.vue"
export default component.exports